import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';

import * as types from '../actionTypes';
import data from './data';

export default combineReducers({
  data,
  loading: loading(types.FETCH_BRANDING_TEMPLATES_REQUEST),
});
